


























import { TransactionType } from "@/enums/enums";
import { GetTransactionRemainPaymentModel } from "@/model/payment/paymentModel";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StorePayment = namespace("Payment");

@Component
export default class ModalConfirmPaymentSuccess extends Vue {
  @Prop({ default: 0 }) transactionId!: number;
  @Prop({ default: 0 }) transactionType!: TransactionType;

  private showModal = true;

  @StorePayment.Action
  private DoGetTransactionRemainPayment!: (input: GetTransactionRemainPaymentModel) => void;

  @Watch("showModal")
  showModalChanged() {
    if (!this.showModal) {
      this.HideModal();
    }
  }

  public GetTransactionRemainPayment() {
    let input = {
      transactionId: this.transactionId,
      transactionType: this.transactionType,
      isConfirmPayment: false,
    };
    this.DoGetTransactionRemainPayment(input);
    this.HideModal();
  }

  public HideModal() {
    this.$emit("update:showModal", false);
  }
}
